import React from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@material-ui/core";


import style from "./style";
const useStyles = makeStyles(style);

const ProductCards = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      {data.map((product) => (
        <Box
          className={` ${classes.cardWrapper} hover-detect`}
        >
          <a href={product.productLink} target="_blank" rel="noreferrer" className="hover-detect">
            <Card data-aos="fade-in" className={classes.card}>
              <CardActionArea>
                {/* <div className={classes.imageOverlay}></div> */}
                <CardMedia
                  className={classes.media}
                  image={product.image}
                  title="Project 1"
                  alt="Card Media Image"
                  style={{ backgroundSize: "cover", }}
                />
              </CardActionArea>
              <CardContent style={{ padding: "20px" }}>
                <Typography data-aos="fade-in" gutterBottom variant="h5" component="h4">
                  {product.title}
                </Typography>
                <Typography data-aos="fade-in" gutterBottom variant="h6" component="h6">
                  {product.description}
                </Typography>
                <Grid className={classes.cardDetails}>
                  <Typography
                    data-aos="fade-in"
                    className={classes.tagName}
                  >
                    {product.tag}
                  </Typography>
                  <Typography
                    data-aos="fade-in"
                    className={classes.price}
                    variant="h6"
                  >
                    {product.price}
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </a>
        </Box>
      ))}
    </>
  );
};

export default ProductCards;
